/**
 * @flow
 * @relayHash 662934e4aebd23de825a311c11da8d8a
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type AdyenSessionsInput = {|
  orderId: string
|};
export type AdyenSessionsMutationVariables = {|
  input: AdyenSessionsInput
|};
export type AdyenSessionsMutationResponse = {|
  +adyenSessions: ?{|
    +id: string,
    +sessionData: string,
  |}
|};
export type AdyenSessionsMutation = {|
  variables: AdyenSessionsMutationVariables,
  response: AdyenSessionsMutationResponse,
|};
*/


/*
mutation AdyenSessionsMutation(
  $input: AdyenSessionsInput!
) {
  adyenSessions(input: $input) {
    id
    sessionData
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "AdyenSessionsInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "adyenSessions",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "AdyenSessionsPayload",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "sessionData",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "AdyenSessionsMutation",
    "type": "RootMutationType",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "AdyenSessionsMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "AdyenSessionsMutation",
    "id": null,
    "text": "mutation AdyenSessionsMutation(\n  $input: AdyenSessionsInput!\n) {\n  adyenSessions(input: $input) {\n    id\n    sessionData\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'a9201e5c338b4698b4bea2d206cde6d5';

module.exports = node;
